<template>
  <div>
    <CollectionView :endpoint="utilities.path(online ? 'communities/@/players/online' : 'communities/@/players', communityId)" :orderable="[{key:'name',name:localization.translate('name')},{key:'identifier',name:localization.translate('identifier')}]" searchable v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("players") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("name") }}</div>
                <div class="table-header-cell">{{ translate("identifier") }}</div>
                <div class="table-header-cell">{{ translate("status") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <RouterLink class="table-row" v-for="item in items" :key="item.id" :to="{ name: 'community.player', params: { playerId: item.id }}">
                  <div class="table-column">
                    <PlayerView :player="item"/>
                  </div>
                  <div class="table-column">
                    {{ item.identifier.value }}
                  </div>
                  <div class="table-column">
                    <i class="fas fa-circle" :class="{ 'text-success': item.online === true, 'text-danger': item.online === false }"></i>
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonKickPlayer v-if="authorization.moduleEnabled(modules.punishments) && item.online && authorization.moduleEnabled(modules.punishments) && authorization.permission('modules.punishments.kicks.create')" :community-id="communityId" :player-id="item.id">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="info" size="small" @click.prevent="show">
                            {{ translate("kick") }}
                          </ButtonView>
                        </template>
                      </ButtonKickPlayer>
                      <ButtonBanPlayer v-if="authorization.moduleEnabled(modules.punishments) && authorization.permission('modules.punishments.bans.create')" :community-id="communityId" :player-id="item.id">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click.prevent="show">
                            {{ translate("ban") }}
                          </ButtonView>
                        </template>
                      </ButtonBanPlayer>
                      <CreateWarningButtonView v-if="authorization.moduleEnabled(modules.punishments) && authorization.permission('modules.punishments.warnings.create')" :community-id="communityId" :player-id="item.id">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="warning" size="small" @click.prevent="show">
                            {{ translate("warn") }}
                          </ButtonView>
                        </template>
                      </CreateWarningButtonView>
                    </div>
                  </div>
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script setup>
import {ButtonView, CollectionView, utilities} from "@/niftybit";
import ButtonKickPlayer from "@/systems/modules/punishments/kicks/ButtonKickPlayer.vue";
import ButtonBanPlayer from "@/systems/modules/punishments/bans/ButtonBanPlayer.vue";
import PlayerView from "@/components/other/PlayerView.vue";
import localization from "@/localization";
import authorization from "@/authorization";
import {onMounted, onUnmounted, ref} from "vue";
import {state} from "@/state";
import {modules} from "@/systems/modules/modules";
import CreateWarningButtonView from "@/systems/modules/punishments/warnings/CreateWarningButtonView.vue";

defineProps({
  communityId: String,
  online: {
    type: Boolean,
    default: false
  }
});

const reload = ref(false);

function onRouteReload() {
  reload.value = true;
}

onMounted(() => {
  state.plugins.reloadRoute.listeners.push(onRouteReload);
});

onUnmounted(() => {
  state.plugins.reloadRoute.listeners = state.plugins.reloadRoute.listeners.filter(item => item !== onRouteReload);
});

</script>